////    CORE    ////
import { LOCALE_ID, NgModule } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

////    COMPONENTS    ////
import { IconModule, LoaderButtonModule } from '@helvetia/components'
import { AppRoutingModule } from 'src/app/app-routing.module'
import { MaterialImporterModule } from 'src/app/shared/material-importer/material-importer.module'
import { StatistiquesComponent } from './statistiques.component'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MarketsModule } from 'src/app/components/markets/markets.module'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { CustomPaginator } from 'src/app/shared/utils/paginator'

@NgModule({
  declarations: [StatistiquesComponent],
  imports: [
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    IconModule,
    LoaderButtonModule,
    MaterialImporterModule,
    MarketsModule
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomPaginator }
]
})
export class StatistiquesModule {}
